module.exports = __webpack_public_path__ + "img/link-to-db.8aea5614.svg";